import { processHTML } from "../../../utils/portfolioUtils";
import "../../../css/Resume.css";

const ProjectItem = ({ project }) => {
  return (
    <div className="project-card">
      <div className="project-card-body">
        <div className="project-meta-top">
          <span className="project-type-label">{project.subtitle || ""}</span>
          <span className="project-year">
            {project.term}
            {project.end_date && ` ${new Date(project.end_date).getFullYear()}`}
          </span>
        </div>
        <h5 className="project-title-text">{project.title}</h5>
        <div
          className="project-description"
          dangerouslySetInnerHTML={{ __html: processHTML(project.description) }}
        />
        <div className="project-card-footer">
          {project.skills && (
            <div className="project-skills">
              {project.skills.split(",").map((skill, i) => (
                <span key={i} className="skill-badge">
                  {skill.trim()}
                </span>
              ))}
            </div>
          )}
          {project.collaborators && (
            <p className="collaborators-text mb-0">
              <strong>With:</strong> {project.collaborators}
            </p>
          )}
          {project.code_link && (
            <div className="paper-links">
              <a
                href={project.code_link}
                target="_blank"
                rel="noopener noreferrer"
                className="paper-link-tag"
              >
                github ↗
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;
